<div id="container-our-story">
  <ngb-carousel
    [showNavigationArrows]="false"
    [showNavigationIndicators]="false">
    <ng-template ngbSlide>
      <div class="picsum-img-wrapper">
        <img src="assets/images/our-story/our-story.png" alt="TSOLife" />
      </div>
      <div class="carousel-caption text-center">
        <h1>OUR STORY STARTED WITH YOUR FAMILIES’ <br />STORIES</h1>
        <a
          class="btn btn-danger btn-lg m-btn-schedule cursor-pointer engagement-contact-btn"
          (click)="triggerScrollTo('front-end-form')"
          >Contact Us To Learn More</a
        >
      </div>
    </ng-template>
  </ngb-carousel>

  <section class="timeline">
    <ul>
      <li class="">
        <div class="line-time-card time-left-position lg-width">
          <div class="row">
            <div class="col-12 img-card">
              <img class="w-100" src="assets/images/our-story/line-time1.png" />
            </div>
            <div class="text-center">
              <h2>
                TSOLife was founded to capture family stories for future
                generations
              </h2>
              <p class="mt-4">
                At TSOLIife, we believe that every person has a unique and
                valuable story to tell. Our founder and CEO, David Sawyer,
                realized he had missed an important opportunity to preserve his
                grandmother's life stories. Wanting to give families an easy way
                to capture their loved ones’ memories and share their life
                experiences with future generations, TSOLIfe's technology was
                born. <br /><br />
                As families began to capture their stories, we realized that the
                technology behind parsing and preserving spoken words could have
                a powerful impact on seniors in residential living. By capturing
                residents’ favorite hobbies, interests, and key life
                experiences, senior living operators can tailor their community
                events accordingly — and help residents make lifelong friends
                based on shared stories.
              </p>
            </div>
          </div>
        </div>
      </li>
      <li class="content-lg-margin">
        <div class="line-time-card time-right-position md-width">
          <div class="row">
            <div class="col-12 img-card">
              <img class="w-100" src="assets/images/our-story/line-time2.png" />
            </div>
          </div>
        </div>
      </li>
      <li class="">
        <div class="line-time-card time-right-position lg-width">
          <div class="row">
            <div class="col-12 img-card">
              <img class="w-100" src="assets/images/our-story/line-time3.png" />
            </div>
            <div class="text-center">
              <h2>Launched Minerva and Resident Engagement platforms</h2>
              <p class="mt-4">
                At the heart of every good senior living community is care. Our
                Al-powered resident insights platform, Minerva, makes it easy to
                capture your residents’ data through spoken interviews — with no
                data entry required. By analyzing the thousands of data points
                it collects, Minerva gives you custom insights on resident
                engagement, quality of life, and demographics to inform your
                sales and marketing efforts. <br /><br />
                To enrich your residents’ lives, our engagement platform also
                makes it easy to pair friends based on shared interests, design
                your activities calendar around their favorite interests, stay
                updated when residents have important anniversaries or
                milestones, and keep families looped in on all of the action
                through our easy communication app. With a thriving, engaging
                community, you can ensure higher resident satisfaction and
                better long-term retention.
              </p>
            </div>
          </div>
        </div>
      </li>
      <li class="content-lg-margin">
        <div class="line-time-card time-left-position md-width">
          <div class="row">
            <div class="col-12 img-card">
              <img
                class="w-100"
                src="assets/images/our-story/closed-series-a.png" />
            </div>
            <div class="text-center">
              <h1 class="red-color">2022</h1>
              <p class="mt-4">Closed series A funding round</p>
            </div>
          </div>
        </div>
      </li>
      <li class="">
        <div class="line-time-card time-left-position md-width">
          <div class="row">
            <div class="col-12 img-card mt-5 last-time-img">
              <img class="w-100" src="assets/images/our-story/line-time5.png" />
            </div>
            <div class="text-center">
              <h1 class="yellow-color">2022</h1>
              <p class="mt-4">
                Acquired Fit Minds, a leading provider of brain fitness and
                cognitive health solutions for the senior living industry
              </p>
            </div>
          </div>
        </div>
      </li>
    </ul>
  </section>

  <section class="staff-container">
    <div class="row text-center">
      <h1 class="text-black fw-bolder staff-main-title">OUR TEAM</h1>
    </div>
    <div class="row">
      <div class="row justify-content-center my-5">
        <div class="col-8 d-flex flex-wrap justify-content-center">
          <img
            class="lg-img"
            src="assets/images/our-story/staff-members/david-sawyer.png"
            alt="DAVID SAWYER" />
          <img
            class="my-auto bg-white rounded-circle tso-logo"
            src="assets/images/brands/tsolife-ico-250x250.png"
            alt="TSOLife" />
          <div class="staff-info-dark-blue my-auto text-center">
            <h1 class="mx-5">DAVID SAWYER</h1>
            <hr />
            <h3 class="mx-5">Founder And CEO</h3>
          </div>
        </div>
      </div>

      <div class="row justify-content-end my-5">
        <div class="col-8 d-flex flex-wrap justify-content-center">
          <img
            class="sm-img"
            src="assets/images/our-story/staff-members/jessica-puccio.png"
            alt="JESSICA PUCCIO" />
          <div class="staff-info-dark-blue2 my-auto text-center">
            <h1 class="mx-5">JESSICA PUCCIO</h1>
            <hr />
            <h3 class="mx-5">Executive Assistant</h3>
          </div>
        </div>
      </div>

      <div class="row justify-content-start flex-column flex-md-row my-5">
        <div
          class="col-7 d-flex flex-wrap justify-content-center mx-auto mx-md-0">
          <img
            class="md-img"
            src="assets/images/our-story/staff-members/sales-marketing/lauren-wilson.png"
            alt="LAUREN WILSON" />
          <div class="staff-info-light-blue my-auto text-center">
            <h1 class="mx-5">LAUREN WILSON</h1>
            <hr />
            <h3 class="mx-5">VP Sales And Marketing</h3>
          </div>
        </div>
        <div
          class="col-5 row staff-info-light-blue align-items-center mx-auto mx-md-0 my-sm-5">
          <h1>SALES AND MARKETING <i class="fas fa-angle-down"></i></h1>
        </div>
      </div>

      <div class="row justify-content-start flex-column flex-md-row my-5">
        <div
          class="col-6 d-flex flex-wrap justify-content-center mx-auto mx-md-0">
          <img
            class="sm-img"
            src="assets/images/our-story/staff-members/sales-marketing/tim-strand.png"
            alt="TIM STRAND" />
          <div class="staff-info-light-blue my-auto text-center">
            <h1 class="mx-2">TIM STRAND</h1>
            <hr />
            <h3 class="mx-2">Director of Sales</h3>
          </div>
        </div>
        <div
          class="col-6 d-flex flex-wrap justify-content-center mx-auto mx-md-0">
          <img
            class="sm-img"
            src="assets/images/our-story/staff-members/sales-marketing/wendy-adams.png"
            alt="WENDY ADAMS" />
          <div class="staff-info-light-blue my-auto text-center">
            <h1 class="mx-2">WENDY ADAMS</h1>
            <hr />
            <h3 class="mx-2">Director of Partnerships</h3>
          </div>
        </div>
      </div>

      <div class="row justify-content-start flex-column flex-md-row my-5">
        <div
          class="col-6 d-flex flex-wrap justify-content-center mx-auto mx-md-0">
          <img
            class="sm-img"
            src="assets/images/our-story/staff-members/sales-marketing/andrew-welch.png"
            alt="ANDREW WELCH" />
          <div class="staff-info-light-blue my-auto text-center">
            <h1 class="mx-2">ANDREW WELCH</h1>
            <hr />
            <h3 class="mx-2">Director of Marketing</h3>
          </div>
        </div>
        <div
          class="col-6 d-flex flex-wrap justify-content-center mx-auto mx-md-0">
          <img
            class="sm-img"
            src="assets/images/our-story/staff-members/sales-marketing/joe-leonard.png"
            alt="JOE LEONARD" />
          <div class="staff-info-light-blue my-auto text-center">
            <h1>JOE LEONARD</h1>
            <hr />
            <h3>Sales And Marketing Manager</h3>
          </div>
        </div>
      </div>

      <div class="row justify-content-start flex-column flex-md-row my-5">
        <div
          class="col-7 d-flex flex-wrap justify-content-center mx-auto mx-md-0">
          <img
            class="md-img"
            src="assets/images/our-story/staff-members/customer-success/allison-mcbryde.png"
            alt="ALLISON MCBRYDE" />
          <div class="staff-info-red my-auto text-center">
            <h1 class="mx-5">ALLISON MCBRYDE</h1>
            <hr />
            <h3 class="mx-5">Director of Customer Success</h3>
          </div>
        </div>
        <div
          class="col-5 row staff-info-red align-items-center mx-auto mx-md-0 my-sm-5">
          <h1>CUSTOMER SUCCESS <i class="fas fa-angle-down"></i></h1>
        </div>
      </div>

      <div class="row justify-content-start flex-column flex-md-row my-5">
        <div
          class="col-6 d-flex flex-wrap justify-content-center mx-auto mx-md-0">
          <img
            class="sm-img"
            src="assets/images/our-story/staff-members/customer-success/jessanna-adams.png"
            alt="JESSANNA ADAMS" />
          <div class="staff-info-red my-auto text-center">
            <h1>JESSANNA ADAMS</h1>
            <hr />
            <h3>Customer Success Manager</h3>
          </div>
        </div>
        <div
          class="col-6 d-flex flex-wrap justify-content-center mx-auto mx-md-0">
          <img
            class="sm-img"
            src="assets/images/our-story/staff-members/customer-success/mackenzie-nozartash.png"
            alt="MACKENZIE NOZARTASH" />
          <div class="staff-info-red my-auto text-center">
            <h1>MACKENZIE NOZARTASH</h1>
            <hr />
            <h3>Customer Success Manager</h3>
          </div>
        </div>
      </div>

      <div class="row flex-sm-column flex-md-row justify-content-start my-5">
        <div
          class="col-6 d-flex flex-wrap justify-content-center mx-auto mx-md-0">
          <img
            class="sm-img"
            src="assets/images/our-story/staff-members/customer-success/phelan-welch.png"
            alt="PHELAN WELCH" />
          <div class="staff-info-red my-auto text-center">
            <h1>PHELAN WELCH</h1>
            <hr />
            <h3>Customer Success Manager</h3>
          </div>
        </div>
        <div
          class="col-6 d-flex flex-wrap justify-content-center mx-auto mx-md-0">
          <img
            class="sm-img"
            src="assets/images/our-story/staff-members/customer-success/kandace-johnstone.png"
            alt="KANDACE JOHNSTONE" />
          <div class="staff-info-red my-auto text-center">
            <h1>KANDACE JOHNSTONE</h1>
            <hr />
            <h3>Customer Success Coordinator</h3>
          </div>
        </div>
      </div>

      <div class="row justify-content-start flex-column flex-md-row my-5">
        <div
          class="col-6 d-flex flex-wrap justify-content-center mx-auto mx-md-0">
          <img
            class="sm-img"
            src="assets/images/our-story/staff-members/customer-success/autumn-barb.png"
            alt="AUTUMN BARB" />
          <div class="staff-info-red my-auto text-center">
            <h1>AUTUMN BARB</h1>
            <hr />
            <h3>Customer Success Coordinator</h3>
          </div>
        </div>
      </div>

      <div class="row justify-content-start flex-column flex-md-row my-5">
        <div
          class="col-6 d-flex flex-wrap justify-content-center mx-auto mx-md-0">
          <img
            class="md-img"
            src="assets/images/our-story/staff-members/production-product/samantha-minasola.png"
            alt="SAMANTHA MINASOLA" />
          <div class="staff-info-green my-auto text-center">
            <h1>SAMANTHA MINASOLA</h1>
            <hr />
            <h3>Production Manager</h3>
          </div>
        </div>
        <div
          class="col-6 d-flex flex-wrap justify-content-center mx-auto mx-md-0">
          <img
            class="md-img"
            src="assets/images/our-story/staff-members/production-product/daniel-sharits.png"
            alt="DANIEL SHARITS" />
          <div class="staff-info-green my-auto text-center">
            <h1>DANIEL SHARITS</h1>
            <hr />
            <h3>Product Delivery Manager</h3>
          </div>
        </div>
      </div>

      <div class="row justify-content-center my-5">
        <div class="col-5 row staff-info-green align-items-center">
          <h1 class="text-center">
            PRODUCTION AND PRODUCT<i class="fas fa-angle-down"></i>
          </h1>
        </div>
      </div>

      <div class="row justify-content-start flex-column flex-md-row my-5">
        <div
          class="col-6 d-flex flex-wrap justify-content-center mx-auto mx-md-0">
          <img
            class="sm-img"
            src="assets/images/our-story/staff-members/production-product/jason-lettieri.png"
            alt="JASON LETTIERI" />
          <div class="staff-info-green my-auto text-center">
            <h1>JASON LETTIERI</h1>
            <hr />
            <h3>Quality Assurance Manager</h3>
          </div>
        </div>
        <div
          class="col-6 d-flex flex-wrap justify-content-center mx-auto mx-md-0">
          <img
            class="sm-img"
            src="assets/images/our-story/staff-members/production-product/austin-moran.png"
            alt="AUSTIN MORAN" />
          <div class="staff-info-green my-auto text-center">
            <h1>AUSTIN MORAN</h1>
            <hr />
            <h3>Quality Assurance</h3>
          </div>
        </div>
      </div>

      <div class="row justify-content-start flex-column flex-md-row my-5">
        <div
          class="col-6 d-flex flex-wrap justify-content-center mx-auto mx-md-0">
          <img
            class="sm-img"
            src="assets/images/our-story/staff-members/production-product/daniel-mansfield.png"
            alt="DANIEL MANSFIELD" />
          <div class="staff-info-green my-auto text-center">
            <h1>DANIEL MANSFIELD</h1>
            <hr />
            <h3>Audio Profile Processing Lead</h3>
          </div>
        </div>
        <div
          class="col-6 d-flex flex-wrap justify-content-center mx-auto mx-md-0">
          <div class="staff-info-green my-auto text-center">
            <h1 class="mx-5">LOGAN CAMP</h1>
            <hr />
            <h3 class="mx-5">Quality Assurance</h3>
          </div>
        </div>
      </div>

      <div class="row justify-content-start flex-column flex-md-row my-5">
        <div
          class="col-6 d-flex flex-wrap justify-content-center mx-auto mx-md-0">
          <img
            class="sm-img"
            src="assets/images/our-story/staff-members/production-product/tandra-mongold.png"
            alt="TANDRA MONGOLD" />
          <div class="staff-info-green my-auto text-center">
            <h1>TANDRA MONGOLD</h1>
            <hr />
            <h3>Story Profile Processing Lead</h3>
          </div>
        </div>
        <div
          class="col-6 d-flex flex-wrap justify-content-center mx-auto mx-md-0">
          <div class="staff-info-green my-auto text-center">
            <h1 class="mx-5">KARINA TORANDO</h1>
            <hr />
            <h3 class="mx-5">Insights</h3>
          </div>
        </div>
      </div>

      <div class="row justify-content-start flex-column flex-md-row my-5">
        <div
          class="col-6 d-flex flex-wrap justify-content-center mx-auto mx-md-0">
          <img
            class="sm-img"
            src="assets/images/our-story/staff-members/production-product/aurora-seward.png"
            alt="AURORA SEWARD" />
          <div class="staff-info-green my-auto text-center">
            <h1>AURORA SEWARD</h1>
            <hr />
            <h3>Paper Profile Processing Lead</h3>
          </div>
        </div>
      </div>

      <div class="row justify-content-start flex-column flex-md-row my-5">
        <div
          class="col-6 d-flex flex-wrap justify-content-center mx-auto mx-md-0">
          <img
            class="md-img"
            src="assets/images/our-story/staff-members/development/amit-patel.png"
            alt="AMIT PATEL" />
          <div class="staff-info-yellow my-auto text-center">
            <h1>AMIT PATEL</h1>
            <hr />
            <h3>Lead Mobile Developer</h3>
          </div>
        </div>
        <div
          class="col-6 d-flex flex-wrap justify-content-center mx-auto mx-md-0">
          <div class="staff-info-yellow my-auto text-center">
            <h1>MAURlCl0 T0VAR</h1>
            <hr />
            <h3>Lead Web Developer</h3>
          </div>
        </div>
      </div>

      <div class="row justify-content-center my-5">
        <div
          class="col-5 row staff-info-yellow justify-content-center align-items-center">
          <h1 class="text-center">DEV TEAM<i class="fas fa-angle-down"></i></h1>
        </div>
      </div>

      <div class="row justify-content-start flex-column flex-md-row my-5">
        <div
          class="col-6 d-flex flex-wrap justify-content-center mx-auto mx-md-0">
          <div class="staff-info-yellow my-auto text-center">
            <h1 class="mx-5">ETHAN HARRIS</h1>
            <hr />
            <h3 class="mx-5">Mobile Developer</h3>
          </div>
        </div>
        <div
          class="col-6 d-flex flex-wrap justify-content-center mx-auto mx-md-0">
          <div class="staff-info-yellow my-auto text-center">
            <h1 class="mx-5">CAROLINA PEREZ</h1>
            <hr />
            <h3 class="mx-5">Web Team</h3>
          </div>
        </div>
      </div>

      <div class="row justify-content-start flex-column flex-md-row my-5">
        <div
          class="col-6 d-flex flex-wrap justify-content-center mx-auto mx-md-0">
          <div class="staff-info-yellow my-auto text-center">
            <h1 class="mx-5">MAHESH</h1>
            <hr />
            <h3 class="mx-5">Mobile Developer</h3>
          </div>
        </div>
        <div
          class="col-6 d-flex flex-wrap justify-content-center mx-auto mx-md-0">
          <div class="staff-info-yellow my-auto text-center">
            <h1 class="mx-5">CATALINA CARDONA</h1>
            <hr />
            <h3 class="mx-5">Web Team</h3>
          </div>
        </div>
      </div>

      <div class="row justify-content-start flex-column flex-md-row my-5">
        <div
          class="col-6 d-flex flex-wrap justify-content-center mx-auto mx-md-0">
          <div class="staff-info-yellow my-auto text-center">
            <h1 class="mx-5">SATYAM</h1>
            <hr />
            <h3 class="mx-5">Mobile Developer</h3>
          </div>
        </div>
        <div
          class="col-6 d-flex flex-wrap justify-content-center mx-auto mx-md-0">
          <div class="staff-info-yellow my-auto text-center">
            <h1 class="mx-5">JAVIER RAMIREZ</h1>
            <hr />
            <h3 class="mx-5">Web Team</h3>
          </div>
        </div>
      </div>

      <div class="row justify-content-start flex-column flex-md-row my-5">
        <div
          class="col-6 d-flex flex-wrap justify-content-center mx-auto mx-md-0">
          <div class="staff-info-yellow my-auto text-center">
            <h1 class="mx-5">JIGNESH</h1>
            <hr />
            <h3 class="mx-5">API Developer</h3>
          </div>
        </div>
        <div
          class="col-6 d-flex flex-wrap justify-content-center mx-auto mx-md-0">
          <div class="staff-info-yellow my-auto text-center">
            <h1 class="mx-5">WILLIAM GOMEZ</h1>
            <hr />
            <h3 class="mx-5">Web Team</h3>
          </div>
        </div>
      </div>

      <div class="row justify-content-start flex-column flex-md-row my-5">
        <div
          class="col-6 d-flex flex-wrap justify-content-center mx-auto mx-md-0">
          <img
            class="md-img"
            src="assets/images/our-story/staff-members/amy-avila.png"
            alt="AMY AVILA" />
          <div class="staff-info-dark-blue2 my-auto text-center">
            <h1>AMY AVILA</h1>
            <hr />
            <h3>Director of Special Projects</h3>
          </div>
        </div>
        <div
          class="col-6 d-flex flex-wrap justify-content-center mx-auto mx-md-0">
          <img
            class="md-img"
            src="assets/images/our-story/staff-members/john-sawyer.png"
            alt="JOHN SAWYER" />
          <div class="staff-info-dark-blue2 my-auto text-center">
            <h1>JOHN SAWYER</h1>
            <hr />
            <h3>Project Manager</h3>
          </div>
        </div>
      </div>

      <div class="row justify-content-start flex-column flex-md-row my-5">
        <div
          class="col-6 d-flex flex-wrap justify-content-center mx-auto mx-md-0">
          <img
            class="sm-img"
            src="assets/images/our-story/staff-members/kerri-shaver.png"
            alt="KERRI SHAVER" />
          <div class="staff-info-dark-blue2 my-auto text-center">
            <h1>KERRI SHAVER</h1>
            <hr />
            <h3>
              Director of Sales and <br />
              Operations (Fit Minds)
            </h3>
          </div>
        </div>
      </div>
    </div>
  </section>

  <div class="card card-home-page-white text-center" id="front-end-form">
    <app-front-end-form titlePosition="right"></app-front-end-form>
  </div>
</div>
